var key = {};
let NODE_ENV = "production"
if (NODE_ENV == "demo") {
  key = {
    baseUrl: "https://winapi.wearedev.team/api",
    getLoginInfo: "https://freeipapi.com/api/json",
    frontUrl: "https://win-frontend.pages.dev",
    imageUrl: "https://winapi.wearedev.team",
    contractAddress: "0xa3eEEe195f986806b46DBE39977e9d8f16E9801B",
    usdtContract: "0x9336E83E6Bb110899b40bC10B74E2E9fECF7922D",
    //vouchor
    vouchorAddress: "0x3A01e86D04fa1E856Dfdd97B3dB71BD1Dc036CDf",
    usdtCont: "0x053baB8D7444dF96f5fbC0DbD6F0eB875AE012AD",
    rpc: "https://data-seed-prebsc-1-s1.binance.org:8545/",
    txurl: "https://testnet.bscscan.com",
    chainId: 97,
    adminAdd: "0xd4C62a86D19494F92A58828f415f3072798F86Ee"
  };
} else if (NODE_ENV == "production") {
  key = {
    baseUrl: "https://prodapi.wincho.io/api",
    getLoginInfo: "https://freeipapi.com/api/json",
    frontUrl: "https://www.wincho.io",
    imageUrl: "https://prodapi.wincho.io",
    contractAddress: "0x9b48CFcB55AC7979cba168e9Ce067B362992294c",
    usdtContract: "0x55d398326f99059fF775485246999027B3197955",
    rpc: "https://bsc-dataseed.binance.org/",
    txurl: "https://bscscan.com",
    chainId: 56,
    //vouchor
    vouchorAddress: "0x671fF8e2FeAE3344E26C84E1DEAcF15E9d0901c3",
    usdtCont: "0x55d398326f99059fF775485246999027B3197955",
    adminAdd: "0xFAFb705D0De76380958e82367c147465452194f1"
  };
} else {
  key = {
    baseUrl: "http://localhost:2020/api",
    getLoginInfo: "https://freeipapi.com/api/json",
    frontUrl: "http://localhost:3000",
    imageUrl: "http://localhost:2020",
    //ico
    contractAddress: "0x9b48CFcB55AC7979cba168e9Ce067B362992294c",
    usdtContract: "0x053baB8D7444dF96f5fbC0DbD6F0eB875AE012AD",
    //vouchor
    vouchorAddress: "0x3A01e86D04fa1E856Dfdd97B3dB71BD1Dc036CDf",
    usdtCont: "0x053baB8D7444dF96f5fbC0DbD6F0eB875AE012AD",
    rpc: "https://data-seed-prebsc-1-s1.binance.org:8545/",
    txurl: "https://testnet.bscscan.com",
    chainId: 97,
    // rpc: "https://bsc-dataseed.binance.org/",
    // txurl: "https://bscscan.com",
    // chainId: 56,
    // adminAdd: "0xd4C62a86D19494F92A58828f415f3072798F86Ee"
    // vouchorAddress: "0x6C7b8b9179cc1Ae52Be233f4D17799ea4AF51caB",
    // usdtCont: "0x99250B58581a07ce569b35eDB058AbcE727B7D50",
    // adminAdd: "0xFAFb705D0De76380958e82367c147465452194f1"
  };
}
export default key;
